<template>
	<div class="coupon-rules-page">
		<header class="rules-heading">
			<button type="button" aria-label="返回我的券包" @click="$router.push({ name: 'MyCoupon' })">
				<i class="el-icon-arrow-left"></i>
			</button>
			<div>
				<h2>优惠券使用规则说明</h2>
				<p>了解优惠券使用规则，享受更优质的服务体验</p>
			</div>
		</header>

		<div class="rules-content">
			<section class="rules-card">
				<h3>
					<i class="el-icon-tickets"></i>
					券类型说明
				</h3>
				<div class="rules-table-wrap">
					<table>
						<thead>
							<tr>
								<th>券类型</th>
								<th>说明</th>
								<th>示例</th>
								<th>使用条件</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td><span class="type-tag full-reduction">满减券</span></td>
								<td>订单金额达到指定门槛后，直接减免固定金额</td>
								<td>满500减100</td>
								<td>订单金额 ≥ 门槛金额</td>
							</tr>
							<tr>
								<td><span class="type-tag discount">折扣券</span></td>
								<td>按订单金额的百分比折扣，可能有最高优惠上限</td>
								<td>8折券，最高优惠200元</td>
								<td>无门槛 / 有门槛</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>

			<section class="rules-card">
				<h3>
					<i class="el-icon-document-checked"></i>
					使用规则
				</h3>
				<div class="rules-table-wrap compact">
					<table>
						<thead>
							<tr>
								<th>规则项</th>
								<th>说明</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>有效期</td>
								<td>券面标注的有效期内使用，过期自动失效</td>
							</tr>
							<tr>
								<td>退款规则</td>
								<td>使用券的订单退款时，券不予退还</td>
							</tr>
							<tr>
								<td>适用范围</td>
								<td>部分券仅限指定品类/指定商品使用，详见券面说明</td>
							</tr>
							<tr>
								<td>领取限制</td>
								<td>同一用户每种活动券限领1张</td>
							</tr>
							<tr>
								<td>金额门槛</td>
								<td>满减券需订单金额达到门槛方可使用</td>
							</tr>
							<tr>
								<td>不可拆分/转让</td>
								<td>优惠券不可拆分、不可转让、不可兑现</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="principle-callout">
					<strong>核心原则：</strong>
					优惠券的使用受叠加策略、适用范围、商品活动价等多重规则约束，系统会自动校验并筛选可用券。
				</div>
			</section>

			<section class="rules-card">
				<h3>
					<i class="el-icon-connection"></i>
					券叠加策略
				</h3>
				<div class="rules-table-wrap">
					<table>
						<thead>
							<tr>
								<th>叠加策略</th>
								<th>说明</th>
								<th>示例</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>不可叠加使用</td>
								<td>该券不可与其他任何优惠券同时使用，一笔订单只能选这一张券</td>
								<td>新人登录券、首单折扣券</td>
							</tr>
							<tr>
								<td>可叠加使用</td>
								<td>该券可与其他同样标记为“可叠加”的券同时使用，享受多重优惠</td>
								<td>—</td>
							</tr>
							<tr>
								<td>互斥组</td>
								<td>同一互斥组内的券只能选一张使用，不同互斥组的券可叠加</td>
								<td>【会员券】组内有5张券，只能选1张</td>
							</tr>
						</tbody>
					</table>
				</div>
				<p class="strategy-note">每张优惠券都有独立的叠加规则。系统会根据以下策略自动判断券是否可用：</p>
				<div class="priority-callout">
					<strong>叠加规则优先级：</strong>
					不可叠加使用 &gt; 互斥组 &gt; 可叠加。如果订单中选了“不可叠加使用”的券，则不能再选其他任何券。
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'CouponRules'
	}
</script>

<style lang="scss" scoped>
	.coupon-rules-page {
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
		color: #34495e;
		background: #f6f8fb;
	}
	.rules-heading {
		display: flex;
		align-items: center;
		gap: 14px;
		padding: 20px 26px;
		border-bottom: 1px solid #e8eef5;
		background: #fff;
	}
	.rules-heading button {
		display: flex;
		width: 36px;
		height: 36px;
		align-items: center;
		justify-content: center;
		border: 1px solid #dbe7f3;
		border-radius: 50%;
		outline: none;
		color: #397fc4;
		background: #f5faff;
		font-size: 17px;
		cursor: pointer;
	}
	.rules-heading button:hover,
	.rules-heading button:focus-visible {
		border-color: #84b6e4;
		background: #eaf5ff;
	}
	.rules-heading h2 {
		margin: 0 0 6px;
		font-size: 22px;
	}
	.rules-heading p {
		margin: 0;
		color: #7d8b9b;
		font-size: 14px;
	}
	.rules-content {
		display: grid;
		gap: 18px;
		padding: 20px;
	}
	.rules-card {
		padding: 22px 24px;
		border-radius: 8px;
		background: #fff;
		box-shadow: 0 4px 16px rgba(31, 74, 117, 0.06);
	}
	.rules-card h3 {
		display: flex;
		align-items: center;
		gap: 9px;
		margin: 0 0 17px;
		color: #2e4358;
		font-size: 18px;
	}
	.rules-card h3 i {
		color: #3985cf;
		font-size: 20px;
	}
	.rules-table-wrap {
		overflow: hidden;
		border: 1px solid #e2eaf2;
		border-radius: 7px;
	}
	table {
		width: 100%;
		border-spacing: 0;
		border-collapse: collapse;
		font-size: 14px;
	}
	th,
	td {
		padding: 13px 15px;
		border-right: 1px solid #e7edf3;
		border-bottom: 1px solid #e7edf3;
		line-height: 22px;
		text-align: left;
	}
	th:last-child,
	td:last-child {
		border-right: 0;
	}
	tbody tr:last-child td {
		border-bottom: 0;
	}
	th {
		color: #365675;
		background: #f1f7fd;
		font-weight: 700;
	}
	td {
		color: #5f6f7f;
	}
	.rules-table-wrap.compact th:first-child,
	.rules-table-wrap.compact td:first-child {
		width: 170px;
		color: #365675;
		font-weight: 700;
	}
	.type-tag {
		display: inline-block;
		padding: 3px 11px;
		border-radius: 13px;
		color: #fff;
		font-weight: 700;
	}
	.type-tag.full-reduction {
		background: #fd663d;
	}
	.type-tag.discount {
		background: #8b5ef5;
	}
	.principle-callout,
	.priority-callout {
		margin-top: 17px;
		padding: 14px 17px;
		border-left: 4px solid #f2994a;
		border-radius: 4px;
		color: #72512e;
		background: #fff7eb;
		font-size: 14px;
		line-height: 24px;
	}
	.priority-callout {
		border-left-color: #397fc4;
		color: #365675;
		background: #eef7ff;
	}
	.strategy-note {
		margin: 17px 0 0;
		color: #5f6f7f;
		font-size: 14px;
		line-height: 24px;
	}
</style>
